import { useMutation } from "react-query";
import { APIError, APIResponse, API_URL, post } from "../api";

function useMarkLivenessVerified() {
  const { isLoading, isError, mutate, error } = useMutation<
    APIResponse<any>,
    APIError,
    void
  >(async () => {
    return post(
      API_URL + "/account/user/account/mark-liveness-verified",
      {},
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );
  });

  return {
    markLivenessVerified: mutate,
    isMarkingLiveness: isLoading,
    markLivenessError: isError,
    markLivenessErrorDetails: error,
  };
}

export default useMarkLivenessVerified;
